import React from "react";
import InspectionOrders from "./inspection";

class InspectionOrdersParent extends React.Component {
    render() {
        return <InspectionOrders/>;
    }
}

export default InspectionOrdersParent;